import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { NgForm, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';


@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  constructor(private UserService: UserService, private router: Router) { }
  data: any;
  user: any;

  ngOnInit() {
    this.getCurrentUser();
  }

  getCurrentUser()
  {
    this.UserService.getUserProfile().subscribe( 
      (data : any) => {
        this.user = data;
        console.log(this.user);
      }
    )
  }

  ResetPasswordForm(form: NgForm) {

    this.UserService.resetpassword(form.value).subscribe(
      (data) => {
        this.data = data;
        alert(this.data);
        this.router.navigate(['/dashboard']);
        console.log(this.data);
        form.reset();
      }
    )

  }
}
